import { useState } from "react"
import { ADD_DEPARTMENT_END_POINT } from "../../../../config/config";
import { api, getToken } from "../../../../services/apis/auth-api/apiUrl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { AxiosError } from "axios";

export default function AddDepartment () {

    const[departmentName, setDepartmentName] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);
    const [submitStat, setSubmitStat] = useState({
        submitted : false,
        msg : ''
    });

    const submitDepartment = async() => {
        if(departmentName === ''){
            setSubmitStat({
                submitted : false,
                msg : 'Please insert department name.'
            })
            return false;
        }

        setLoading(true);
        
        try{
            await api.post(ADD_DEPARTMENT_END_POINT, {name : departmentName}, 
                {headers : {'Authorization' : 'Bearer '+getToken()}
            });
            setSubmitStat({
                submitted : true,
                msg : 'New department added'
            })
            setLoading(false);
        }catch(e){
            const error = (e as AxiosError);
            setLoading(false);
            if(error.response?.status === 401){
                setSubmitStat({
                    submitted : false,
                    msg : 'Unauthorized access'
                })
            }else{
                setSubmitStat({
                    submitted : false,
                    msg : 'An error occured!'
                })
            }
        }
    } 

    return(
        <div className="min-w-80">
            <div>
                Add new department
            </div>
            <div className={submitStat.submitted ? 'text-green-500' : 'text-red-500'}>
                {submitStat.msg}
            </div>
            <div className="input-container">
                <input type="text" 
                    className="text-box" 
                    onChange={(e)=>setDepartmentName(e.target.value)} 
                    value={departmentName} placeholder="Department name" 
                />
            </div>
            <div className="input-container">
                {loading ? (
                    <button type="button" disabled className='button button-disabled'>
                        <FontAwesomeIcon className='animate-spin' icon={faSpinner} />  Processing....
                    </button>
                ) : (
                    <button type="button" onClick={submitDepartment} className="button button-vcc-primary">
                        Add Department
                    </button>
                )}
            </div>
        </div>
    )
}